// src/features/audit/components/AuditMetadataCard.tsx
import { Card } from '../../../app/components/foundation';
import type { AuditMetadata } from '../data/audit.mock';

export interface AuditMetadataCardProps {
  metadata: AuditMetadata | undefined;
}

/**
 * Workspace card: raw request metadata for this audit event — IP
 * address, user agent, and any extra metadata lines. `metadata` comes
 * from useAuditWorkspaceMock. Field-list for IP/user agent combined
 * with a simple list for extra metadata, same combined pattern as
 * security/components/SecurityPolicyCard.tsx (dl fields + ul list).
 */
export function AuditMetadataCard({ metadata }: AuditMetadataCardProps) {
  return (
    <Card className="vania-audit-workspace-card">
      <h2 className="vania-audit-workspace-card-title">اطلاعات فنی</h2>

      {!metadata ? (
        <p className="vania-audit-workspace-empty">اطلاعات فنی برای این رخداد ثبت نشده است.</p>
      ) : (
        <>
          <dl className="vania-audit-workspace-fieldlist">
            <div>
              <dt>آدرس IP</dt>
              <dd dir="ltr">{metadata.ip}</dd>
            </div>
            <div>
              <dt>User Agent</dt>
              <dd dir="ltr">{metadata.userAgent}</dd>
            </div>
          </dl>

          {metadata.extra.length === 0 ? (
            <p className="vania-audit-workspace-empty">اطلاعات تکمیلی دیگری ثبت نشده است.</p>
          ) : (
            <ul className="vania-audit-workspace-list">
              {metadata.extra.map((line) => (
                <li key={line} className="vania-audit-workspace-list-item">
                  <span className="vania-audit-workspace-list-primary">{line}</span>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </Card>
  );
}
